var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$store.state.user.subscription.update_url
    ? _c(
        "ib-dialog",
        {
          staticClass: "change-billing-dialog",
          attrs: { visible: _vm.visible, "empty-header": "", fullscreen: "" },
          on: {
            close: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c(
            "ib-dialog-container",
            {
              staticClass: "change-billing-container position-relative",
              attrs: { "max-width": "100%" },
            },
            [
              _c("iframe", {
                staticClass: "mt-4 mt-md-0",
                attrs: {
                  src: _vm.$store.state.user.subscription.update_url,
                  frameborder: "0",
                },
              }),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }